




























































import {Component, Vue, Prop} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import {DiagramData} from '@/interfaces/diagrams';

@Component({
  components: {
    highcharts: Chart,
  },
})
export default class AngleDiagram extends Vue {
  @Prop({required: true, default: {}})
  chartData!: DiagramData;

  angles: any = [];

  amplitudes: any = [];

  angleValues: any = [];

  amplitudeValues: any = [];

  showFirstline = true;
  showSecondline = true;
  showThirdline = true;

  get firstLineStyle() {
    return this.angles[0] && this.amplitudes[0]
      ? {
          'transform': `rotate(${this.angles[0]}deg)`,
          'width': `${this.amplitudes[0]}%`,
        }
      : null;
  }

  get secondLineStyle() {
    return this.angles[1] && this.amplitudes[1]
      ? {
          'transform': `rotate(${this.angles[1]}deg)`,
          'width': `${this.amplitudes[1]}%`,
        }
      : null;
  }

  get thirdLineStyle() {
    return this.angles[2] && this.amplitudes[2]
      ? {
          'transform': `rotate(${this.angles[2]}deg)`,
          'width': `${this.amplitudes[2]}%`,
        }
      : null;
  }

  setValues() {
    const data = this.chartData.data;
    this.angles = [];
    this.amplitudes = [];
    this.angleValues = data.map(x => Math.round((x.angle * 180) / Math.PI));
    this.amplitudeValues = data.map(x => x.amplitude.toFixed(4));
    this.angleValues.forEach((x: any) => {
      this.angles.push(x + 90);
    });
    this.amplitudeValues.forEach((x: any) => {
      const val = (x / Math.max(...this.amplitudeValues)) * 50;
      this.amplitudes.push(Math.round(val));
    });
  }

  created() {
    this.setValues();
  }
}
